/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgreementItem } from '../../models/agreement-item';
import { AgreementMaintenanceCreateDto } from '../../models/agreement-maintenance-create-dto';
import { BaseResponse } from '../../models/base-response';

export interface AgreementsControllerUpdateMaintenance$Params {
  id: number;
      body: AgreementMaintenanceCreateDto
}

export function agreementsControllerUpdateMaintenance(http: HttpClient, rootUrl: string, params: AgreementsControllerUpdateMaintenance$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>> {
  const rb = new RequestBuilder(rootUrl, agreementsControllerUpdateMaintenance.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AgreementItem;
      }>;
    })
  );
}

agreementsControllerUpdateMaintenance.PATH = '/agreements/maintenance/{id}';
